import { render, staticRenderFns } from "./CurrentFilterList.vue?vue&type=template&id=7801f04c&scoped=true&"
import script from "./CurrentFilterList.vue?vue&type=script&lang=js&"
export * from "./CurrentFilterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7801f04c",
  null
  
)

export default component.exports